import React from "react";
import InputTitle from "./InputTitle";
import BreadcrumbsBase from "../buttons/Breadcrumbs";
import ButtonBase from "../buttons/ButtonBase";

import { useForm, FormProvider } from "react-hook-form";

const AddSectionForm = ({data, onSubmit}) => {

    const {handleSubmit, ...methods} = useForm({
        defaultValues: data || null,
    })

    const sendForm = async data => {
        try {
            onSubmit(data)

        } catch (e) {
            console.error(e);
        }
    };

    return (
        <FormProvider {...methods}>
            <form className="pb-8 pl-6 pt-16 flex flex-col gap-8" onSubmit={handleSubmit(sendForm)}>
                <InputTitle name="title" placeholder="Введите название" />
                <ButtonBase type="submit">Сохранить</ButtonBase>
            </form>
        </FormProvider>

    );
};

export default AddSectionForm;